export const Types = {
  GET_LIST_USUARIOS: "usuarios/GET_LIST_USUARIOS",
  GET_LIST_USUARIOS_SUCCESS: "usuarios/GET_LIST_USUARIOS_SUCCESS",
  GET_USUARIOS: "usuarios/GET_USUARIOS",
  GET_USUARIOS_SUCCESS: "usuarios/GET_USUARIOS_SUCCESS",
  EDIT_USUARIOS: "usuarios/EDIT_USUARIOS",
  ADD_USUARIOS: "usuarios/ADD_USUARIOS",
  DELETE_USUARIOS: "usuarios/DELETE_USUARIOS",
  SEARCH_USUARIOS: "usuarios/SEARCH_USUARIOS",
  CHANGE_PAGE_USUARIOS: "usuarios/CHANGE_PAGE_USUARIOS",
  CHANGE_ROWS_PER_PAGE_USUARIOS: "usuarios/CHANGE_ROWS_PER_PAGE_USUARIOS",
  GET_LIST_USUARIOS_SELECTS: "usuarios/GET_LIST_USUARIOS_SELECTS",
  GET_LIST_USUARIOS_SUCCESS_SELECTS:
    "usuarios/GET_LIST_USUARIOS_SUCCESS_SELECTS",
  CHANGE_FILTER: "usuarios/CHANGE_FILTER",
  DELETE_ALL_USUARIOS: "usuarios/DELETE_ALL_USUARIOS",
  GET_USUARIO_LOCAL_WORKING: "usuarios/GET_USUARIO_LOCAL_WORKING",
  GET_USUARIO_LOCAL_WORKING_SUCCESS: "usuarios/GET_USUARIO_LOCAL_WORKING_SUCCESS",
  ADD_USUARIO_LOCAL_WORKING: "usuarios/ADD_USUARIO_LOCAL_WORKING",
  EDIT_USUARIO_LOCAL_WORKING: "usuarios/EDIT_USUARIO_LOCAL_WORKING",
  DELETE_USUARIO_LOCAL_WORKING: "usuarios/DELETE_USUARIO_LOCAL_WORKING"
};

const INITIAL_STATE = {
  data: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  filter: {
    status: "actived"
  },
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0
};

export default function usuarios(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_USUARIOS:
      return { ...state };
    case Types.GET_LIST_USUARIOS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total
      };
    case Types.GET_USUARIOS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.ADD_USUARIOS:
      return { ...state };
    case Types.DELETE_USUARIOS:
      return { ...state };
    case Types.CHANGE_PAGE_USUARIOS:
      return { ...state, page: action.payload.page };
    case Types.SEARCH_USUARIOS:
      return { ...state, filter: action.payload.filter };
    case Types.CHANGE_ROWS_PER_PAGE_USUARIOS:
      return { ...state, rowsPerPage: action.payload.total };
    case Types.GET_LIST_USUARIOS_SELECTS:
      return { ...state, loadingSelect: true };
    case Types.GET_LIST_USUARIOS_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.usuarios,
        loadingSelect: false
      };
    case Types.CHANGE_FILTER:
      return {
        ...state,
        filter: action.payload.data
      };
    case Types.DELETE_ALL_USUARIOS:
      return { ...state };
    case Types.GET_USUARIO_LOCAL_WORKING_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    default:
      return state;
  }
}

export const Creators = {
  getListUsuarios: () => ({
    type: Types.GET_LIST_USUARIOS
  }),
  getListUsuariosSuccess: (data, total) => ({
    type: Types.GET_LIST_USUARIOS_SUCCESS,
    payload: { data, total }
  }),
  getUsuarios: id => ({
    type: Types.GET_USUARIOS,
    payload: { id }
  }),
  getUsuariosSuccess: data => ({
    type: Types.GET_USUARIOS_SUCCESS,
    payload: { data }
  }),
  editUsuarios: data => ({
    type: Types.EDIT_USUARIOS,
    payload: data
  }),
  addUsuarios: data => ({
    type: Types.ADD_USUARIOS,
    payload: data
  }),
  deleteUsuarios: () => ({
    type: Types.DELETE_USUARIOS
  }),
  searchUsuarios: filter => ({
    type: Types.SEARCH_USUARIOS,
    payload: { filter }
  }),
  changeUsuariosPage: page => ({
    type: Types.CHANGE_PAGE_USUARIOS,
    payload: { page }
  }),
  changeUsuariosRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_USUARIOS,
    payload: { total }
  }),
  getListUsuariosSelects: () => ({
    type: Types.GET_LIST_USUARIOS_SELECTS
  }),
  getListUsuariosSuccessSelects: usuarios => ({
    type: Types.GET_LIST_USUARIOS_SUCCESS_SELECTS,
    payload: { usuarios }
  }),
  changeFilter: data => ({
    type: Types.CHANGE_FILTER,
    payload: { data }
  }),
  deleteAllRegioes: selected => ({
    type: Types.DELETE_ALL_USUARIOS,
    payload: { selected }
  }),
  getUsuarioLocalWorking: id => ({
    type: Types.GET_USUARIO_LOCAL_WORKING,
    payload: { id }
  }),
  getUsuarioLocalWorkingSuccess: data => ({
    type: Types.GET_USUARIO_LOCAL_WORKING_SUCCESS,
    payload: { data }
  }),
  addUsuarioLocalWorking: data => ({
    type: Types.ADD_USUARIO_LOCAL_WORKING,
    payload: data
  }),
  editUsuarioLocalWorking: data => ({
    type: Types.EDIT_USUARIO_LOCAL_WORKING,
    payload: data
  }),
  deleteUsuarioLocalWorking: data => ({
    type: Types.DELETE_USUARIO_LOCAL_WORKING,
    payload: data
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/usuarios.js